import { PublisherGameStatusLabel } from "@seabrookstudios/pitch2table-core";
import { plainInboxMatchHint } from "./inboxMatchHints";

/**
 * @param {import("@seabrookstudios/pitch2table-core").GameSummary|null|undefined} game
 * @param {{ publisherName: string }} publisherGame
 * @returns {string}
 */
export const suggestedMatchPrimary = (game, publisherGame) => {
  return game?.name || publisherGame.publisherName;
};

/**
 * @param {import("@seabrookstudios/pitch2table-core").GameSummary|null|undefined} game
 * @param {{
 *   publisherName: string,
 *   status: import("@seabrookstudios/pitch2table-core").PublisherGameStatus,
 * }} publisherGame
 * @param {import("@seabrookstudios/pitch2table-core").InboxMatchReason[]|null|undefined} reasons
 * @returns {string}
 */
export const suggestedMatchSecondary = (game, publisherGame, reasons) => {
  const statusLabel = PublisherGameStatusLabel[publisherGame.status] || publisherGame.status;
  const hint = plainInboxMatchHint(reasons);

  if (game) {
    return [publisherGame.publisherName, statusLabel, hint].filter(Boolean).join(" · ");
  }

  return [statusLabel, hint].filter(Boolean).join(" · ");
};

/**
 * @param {import("@seabrookstudios/pitch2table-core").GameSummary|null|undefined} game
 * @param {import("@seabrookstudios/types").GameId|null|undefined} publisherGameGameId
 * @param {boolean} gamesLoading
 * @returns {'cover'|'loading'|'empty'}
 */
export const suggestedMatchAvatarKind = (game, publisherGameGameId, gamesLoading) => {
  if (game) {
    return "cover";
  }
  if (publisherGameGameId && gamesLoading) {
    return "loading";
  }
  return "empty";
};
